import { render, staticRenderFns } from "./RcvED_Details.vue?vue&type=template&id=7f953760"
import script from "./RcvED_Details.vue?vue&type=script&lang=js"
export * from "./RcvED_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports